/* global ajaxurl, agendaPackDownload */
(function ($) {
	'use strict';

	/**
	 * Generate and download agenda pack
	 */
	function generateAndDownloadPack() {
		const $button = $('#generate-and-download-pack');

		if (!$button.length) {
			return;
		}

		const agendaId = $button.data('agenda-id');

		if (!agendaId) {
			return;
		}

		const ajaxUrl =
			typeof agendaPackDownload !== 'undefined' && agendaPackDownload.ajaxUrl
				? agendaPackDownload.ajaxUrl
				: ajaxurl || '/wp-admin/admin-ajax.php';
		const nonce =
			typeof agendaPackDownload !== 'undefined' && agendaPackDownload.nonce
				? agendaPackDownload.nonce
				: '';
		const packAction =
			typeof agendaPackDownload !== 'undefined' && agendaPackDownload.packAction
				? agendaPackDownload.packAction
				: 'generate_public_facing_agenda_pack';

		$button
			.prop('disabled', true)
			.html(
				'<span class="dashicons dashicons-update-alt rotating"></span> Generating PDF...'
			);

		$.ajax({
			url: ajaxUrl,
			type: 'POST',
			data: {
				action: packAction,
				nonce: nonce,
				agenda_id: agendaId,
			},
			success: function (response) {
				if (response.success && response.data.pdf_url) {
					const downloadLink = document.createElement('a');
					downloadLink.href = response.data.pdf_url;
					downloadLink.download = 'agenda-pack.pdf';
					document.body.appendChild(downloadLink);
					downloadLink.click();
					document.body.removeChild(downloadLink);

					$button.replaceWith(
						`<a href="${response.data.pdf_url}" class="button button-primary download-agenda-pack" download style="display: inline-flex; align-items: center; gap: 5px; padding: 8px 16px; background: #0073aa; color: #fff; text-decoration: none; border-radius: 4px; font-weight: 600;">
							<span class="dashicons dashicons-download" style="font-size: 18px;"></span>
							Download Agenda Pack
						</a>`
					);

					showMessage('Agenda pack generated successfully!', 'success');
				} else {
					showMessage(
						response.data.message || 'Failed to generate agenda pack.',
						'error'
					);
					$button
						.prop('disabled', false)
						.html(
							'<span class="dashicons dashicons-media-document"></span> Generate Agenda Pack'
						);
				}
			},
			error: function () {
				showMessage('An error occurred. Please try again.', 'error');
				$button
					.prop('disabled', false)
					.html(
						'<span class="dashicons dashicons-media-document"></span> Generate Agenda Pack'
					);
			},
		});
	}

	/**
	 * Show message
	 */
	function showMessage(message, type) {
		const bgColor = type === 'success' ? '#d4edda' : '#f8d7da';
		const borderColor = type === 'success' ? '#c3e6cb' : '#f5c6cb';
		const textColor = type === 'success' ? '#155724' : '#721c24';
		const icon = type === 'success' ? 'yes' : 'warning';

		const $messageBox = $(
			`<div class="agenda-pack-message" style="position: fixed; top: 20px; right: 20px; z-index: 9999; max-width: 400px; background: ${bgColor}; border: 1px solid ${borderColor}; color: ${textColor}; padding: 15px; border-radius: 4px; box-shadow: 0 2px 8px rgba(0,0,0,0.15);"><span class="dashicons dashicons-${icon}"></span> ${message}</div>`
		);

		$('body').append($messageBox);

		setTimeout(function () {
			$messageBox.fadeOut(function () {
				$(this).remove();
			});
		}, 5000);
	}

	$(document).ready(function () {
		$(document).on(
			'click',
			'#generate-and-download-pack',
			generateAndDownloadPack
		);
	});

	if (!$('style#rotating-animation').length) {
		$(
			'<style id="rotating-animation">@keyframes rotating { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } .rotating { animation: rotating 1s linear infinite; display: inline-block; }</style>'
		).appendTo('head');
	}
})(jQuery);
